import FinderBase from '../FinderBase/FinderBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import topic from 'dojo/topic';

import "../FinderViewBase/FinderViewBaseTypes";

import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import "../../moreCore/UI/StaticTable/StaticTable";

import NestedTable from '../../moreCore/UI/NestedTable/NestedTable';
import "../../moreCore/UI/NestedTable/NestedTable";

import moreCoreCalendar from '../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar';
import "../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar";
import Calendar_Buttons from '../../moreCore/UI/moreCoreCalendar/Calendar_Buttons/Calendar_Buttons';
import "../../moreCore/UI/moreCoreCalendar/Calendar_Buttons/Calendar_Buttons";
import FullscreenDialog from '../../moreCore/UI/FullscreenDialog/FullscreenDialog';
import "../../moreCore/UI/FullscreenDialog/FullscreenDialog"; 

class FinderViewBase extends compose(FinderBase) {

    calendar: MdsLax<InstanceType<typeof moreCoreCalendar>>;
    calendarButtons: MdsLax<InstanceType<typeof Calendar_Buttons>>;
    fullScreenDlg: MdsLax<InstanceType<typeof FullscreenDialog>>;

    _loadCalendarDataTimeout: number = null;
    _loadCalendarDataRequiest: any = null;

    documentTitle: string;

    _isMobile: boolean = false;

    _isActiveDateRange: boolean = true; // set to false, wenn die FilterRusult nicht chronologisch geordnet sind

    protected dateRangeStart: Date ; // define max and min daterange pro wiget, damit die gleiche daten nicht 2 mal geladen werden
    protected dateRangeEnd: Date ; // define max and min daterange pro wiget, damit die gleiche daten nicht 2 mal geladen werden
    //_completeList_lastResponse_LastEntityIndex: number;
    //_completeList_lastResponse_FirstEntityIndex: number;
    protected _layouts: Array<StaticTable.Layout>;

    protected tableEntityPath: string;
    protected calendarEntityPath: string;  // path für root object mit calender Metadata und parent of Items Array.

    protected calendarItemsArray_API_name: string = "items"; // default
    protected calendarMode_API_name: string = "mode"; // default
    protected calendarDisplayDate_API_name: string = "displayDate"; // default

    private widgetRegistry: Array<widgetRegistryObj> = []; 

    // Das hier brauchen wir weil wir für das Kalendar die Daten im DateRange von kalender selbst laden, und nicht im Range von FilterpanelControls
    protected filterOptionSearch: string = "searchParameter"; // default
    protected filterOptionDateStart: string = "startTime"; // default
    protected filterOptionDateEnd: string = "endTime"; // default

    protected calendar_columnViewHeadTextAttr: string = "barview_text"; // default
    protected calendar_columnViewBodyTextAttr: string = "columnview_head_text";  // default

    //// Widget REgistry -------------------------------------------------START

    //{widgetId ?: string; widgetName ?: string;widgetType ?: string;widget ?: any;node ?: HTMLElement;requestUrl ?: string; dataPropertyName?: string; entityPropertyname ?: string;}
    protected addWidgetToRegistry(widget: any, containerNode: HTMLElement, widgetName?: string, tableLayoutName?: string): void {
        
        if (widget && widget.id && widget.id.indexOf("_") != -1) {
            let index: number = -1;

            if (this.widgetRegistry == null) this.widgetRegistry = [];

            let widgetRegistryObj: widgetRegistryObj = { widget: widget, containerNode: containerNode, widgetId: widget.id, widgetType: (<string>widget.id).slice(0, (<string>widget.id).indexOf("_")) };
            if (widgetName) widgetRegistryObj.widgetName = widgetName;
            if (tableLayoutName) widgetRegistryObj.tableLayoutName = tableLayoutName;

            for (let i = 0; i < this.widgetRegistry.length; i++) {
                if (this.widgetRegistry[i].widgetId == widget.id) {
                    this.widgetRegistry[i] = widgetRegistryObj;
                    index = i;
                }
            }

            if (index == -1) {
                this.widgetRegistry.push(widgetRegistryObj);
            }
        }
    }

    protected clearWidgetRegistry(): void {

        for (let widgetObj of this.widgetRegistry) {
            widgetObj.widget.destroy();
        }
        this.widgetRegistry = [];
    }

    //////id is for internal use, so we dont delete the wrong widget id it has the same name by accident. 
    ////// from outside we communicate with widgets by name
    //------------------------------------------------------------
    protected getWidgetById(id: string): any {
        if (id && this.widgetRegistry.length) {

            for (let i = 0; i < this.widgetRegistry.length; i++) {
                if (this.widgetRegistry[i].widgetId == id) {
                    return this.widgetRegistry[i].widget
                }
            }
        }

        return null;
    }
    protected removeWidgetById(id: string): void {
        if (id && this.widgetRegistry.length) {
            let index: number = -1;
            for (let i = 0; i < this.widgetRegistry.length; i++) {
                if (this.widgetRegistry[i].widgetId == id) {
                    this.widgetRegistry[i].widget.destroy();
                    index = i;
                }
            }

            if (index >= 0) {
                this.widgetRegistry.splice(index, 1);
            }
        }
    }
    protected removeWidgetByName(name: string): void {
        if (name && this.widgetRegistry.length) {
            let index: number = -1;
            for (let i = 0; i < this.widgetRegistry.length; i++) {
                if (this.widgetRegistry[i].widgetName == name) {
                    this.widgetRegistry[i].widget.destroy();
                    index = i;
                }
            }

            if (index >= 0) {
                this.widgetRegistry.splice(index, 1);
            }
        }
    }
    protected getWidgetRegistryObjByWidgetId(widgetId: string): widgetRegistryObj {
        for (let i = 0; i < this.widgetRegistry.length; i++) {
            if (this.widgetRegistry[i].widgetId == widgetId) {
                return this.widgetRegistry[i]
            }
        }
        return null;
    }

    protected getWidgetByName(name: string): any {
        if (name && this.widgetRegistry.length) {

            for (let i = 0; i < this.widgetRegistry.length; i++) {
                if (this.widgetRegistry[i].widgetName == name) {
                    return this.widgetRegistry[i].widget
                }
            }
        }

        return null;
    }

    /*!widgetType is (<string>widget.id).slice(0,(<string>widget.id).indexOf("_"))! e.g. if  id == "StaticTable_0", type == "StaticTable"*/ 
    protected getWidgetsByType(type : string): Array<any> {
        let result = [];

        for (let i = 0; i < this.widgetRegistry.length; i++) {
            if (this.widgetRegistry[i].widgetType == type) {
                result.push(this.widgetRegistry[i].widget);
            }
        }
        return result;
    }

    // den ganzen WidgetRegistryObj bekommen
    //{widgetId ?: string; widgetName ?: string;widgetType ?: string;widget ?: any;node ?: HTMLElement;requestUrl ?: string;entityPropertyname ?: string;}
    protected getWidgetRegistryObjByWidgetName(widgetName: string): widgetRegistryObj {
        for (let i = 0; i < this.widgetRegistry.length; i++) {
            if (this.widgetRegistry[i].widgetName == widgetName) {
                return this.widgetRegistry[i]
            }
        }
        return null;
    }

    //// Widget REgistry ------------------------------------------------END

    dateToStringISO(date: Date): string {

        if (date && Object.prototype.toString.call(date) === "[object Date]") {

            if (isNaN(date.getFullYear())) {
                return null;
            }

            let day = ("0" + date.getDate()).slice(-2); //DD
            let month = ("0" + (date.getMonth() + 1)).slice(-2); //MM
            let year = date.getFullYear() //YYYY
            let hours = ("0" + date.getHours()).slice(-2); // HH
            let min = ("0" + date.getMinutes()).slice(-2);  // mm
            let sec = ("0" + date.getSeconds()).slice(-2); // ss

            // YYYY-MM-DDTHH:mm:ss
            let ISOString = `${year}-${month}-${day}T${hours}:${min}:${sec}`;
            return ISOString;
        }

        return null;
    }


    displayDataSection(targetNode?: HTMLElement, style: "start" | "end" = "start", highlightClass?: string, removeTimeout?: number) {
        this.UiModder.domClass.remove(this.resultContainer, "w3-hide");

        if (!targetNode) {
            targetNode = this.resultContainer;
        }

        targetNode.scrollIntoView({
            behavior: "smooth",
            block: style,
        });

        if (highlightClass) {
            this.UiModder.domClass.add(targetNode, highlightClass);

            if (removeTimeout) {
                setTimeout(lang.hitch(this, this.UiModder.domClass.remove, targetNode, highlightClass), removeTimeout);
            }
        }
    }

    ////  common View default ------------------------------------------END


    //// CALENDAR handling ---------------------------------------------------START

    // Das hier brauchen wir weil wir für den Kalendar die Daten im DateRange von kalender selbst laden, und nicht im Range von FilterPanelControls
    loadCalendarData(customRequestUrl?:string): void {

        if (this.calendar) {
            if (!this.loadFilterDatatUrl) {
                alert("No calendar Request Url in the function args!");
                return;
            }

            if (this.calendar._timeInterval && this.calendar._timeInterval[0] && this.calendar._timeInterval[1]) {

                //// Daten nur laden, wenn this.calendar._timeInterval[0] || this.calendar._timeInterval[1] außerhalb der vorhandenen datumsIntervalAbschnits liegen

                ////Kalendar range innerhalb der bereits der geladenen Daten
                if (this.dateRangeStart && this.dateRangeEnd) {

                    if (this.calendar._timeInterval[0] > this.dateRangeStart && this.calendar._timeInterval[0] < this.dateRangeEnd
                        && this.calendar._timeInterval[1] > this.dateRangeStart && this.calendar._timeInterval[1] < this.dateRangeEnd) {

                        //console.log("NO REQUEST SETDATA");

                        this._onLoadCalendarDataResult(this.lastResponse);

                        return;
                    }
                }

                // wenn wir last response überschreiben, müssen wir die dateRanges loslassen
                this.dateRangeStart = null;
                this.dateRangeEnd = null;

                this.StandbyStart(this.calendar.domNode);
                var url = window.appRoot + this.loadFilterDatatUrl;
                this._isRequestActive = true;

                var data = JSON.parse(this._currentFilterSettings);

                // Dates für den Calendar tweaken
                for (var section of data.sections) {
                    if (section._sectionName == this.filterOptionSearch) {
                        section[this.filterOptionDateStart] = this.dateToStringISO(this.calendar._timeInterval[0]);
                        section[this.filterOptionDateEnd] = this.dateToStringISO(this.calendar._timeInterval[1]);
                    }
                }

                //console.log("LOAD CALENDAR DATA::: ", data)

                var stringData = JSON.stringify(data);

                //console.log("loadCalendarData DATA: ", data);

                if (this._loadCalendarDataRequiest != null) {
                    this._loadCalendarDataRequiest.cancel();
                }

                this._loadCalendarDataRequiest = this.RequestManager.post(
                    url,
                    {
                        jsonData: stringData
                    },
                    lang.hitch(this, "_onLoadCalendarDataResult"),
                    lang.hitch(this, "_onLoadCalendarDataError"),
                    false // sync
                );

            } else {
                console.log("this.calendar._timeInterval[0] && this.calendar._timeInterval[1] needed");
            }
        } else {
            alert("no calendar to load data for");
        }
    }

    // zu diesem Moment ist der Kalender bereits instanziiert und platziert
    _onLoadCalendarDataResult(response: any): void {

        let widgetRegistryObj: widgetRegistryObj;
        let calendarPath: string = null; // path für root obj mit calender Metadata und parent of Items Array
        let calendarItemsList: Array<moreCoreCalendarItem> = [];

        let calendarMode: string = null;
        let calendarDisplayDate: string | Date = null;

        // den richtigen calender finden

        widgetRegistryObj = this.getWidgetRegistryObjByWidgetId(this.calendar.id);

        //richtige Daten Finden
        if (response) {

            if (this.calendarEntityPath) calendarPath = this.calendarEntityPath;

            // bedenke dass calendarItemsList auch leer sein kann
            if (this.entityListAttributeName && response[this.entityListAttributeName]) {

                // wenn calendar items in ein array verpackt sind
                if (this.entityListAttributeName == this.calendarItemsArray_API_name) { // response.items[]
                    calendarItemsList = response[this.entityListAttributeName];
                    if (this.calendarMode_API_name && response[this.calendarMode_API_name]) calendarMode = response[this.calendarMode_API_name];
                    if (this.calendarDisplayDate_API_name && response[this.calendarDisplayDate_API_name]) calendarDisplayDate = response[this.calendarDisplayDate_API_name];
                }
                else if (response[calendarPath][this.calendarItemsArray_API_name])
                { 
                    calendarItemsList = response[calendarPath][this.calendarItemsArray_API_name]; //response.calendarpath.items[] // just in case.. 
                    if (this.calendarMode_API_name && response[this.calendarMode_API_name]) calendarMode = response[this.calendarMode_API_name];
                    if (this.calendarDisplayDate_API_name && response[this.calendarDisplayDate_API_name]) calendarDisplayDate = response[this.calendarDisplayDate_API_name];
                }
                else
                {
                    // wenn die items verschachtelt sind und man sie 1 by 1 extrahieren muss // response.entiylist[0].someObject.calendarItem
                    for (let entity of response[this.entityListAttributeName]) {
                        let calendarEntity: object;

                       if (calendarPath) {
                            calendarEntity = this.PitHelper.getEntityAttributeValue(entity, calendarPath, more.PitHelperStructureFormatType.json);
                            if (!calendarEntity) {
                                console.log("PitHelper could not get the entityAttributeValue for ", calendarPath, " in ", entity);
                            } else {
                                if (calendarEntity[this.filterOptionDateStart] && calendarEntity[this.filterOptionDateEnd]) { // doublchecking for the mandatory properties
                                    calendarItemsList.push(<moreCoreCalendarItem>calendarEntity);
                                } else {
                                    console.log("seems like you've got the wrong entity for the calendar at", calendarPath, " in ", entity);
                                }
                            }
                        }
                    }
                }

            } else {
                alert("set this.entityListAttributeName to indicate the data Array!")
            }

            this.StandbyStop();

            this._isRequestActive = false;


            //DateRAnge aktualisieren
            if (this.dateRangeStart && this.dateRangeEnd) {
                if (this.calendar._timeInterval[0] < this.dateRangeStart) this.dateRangeStart = this.calendar._timeInterval[0];
                if (this.calendar._timeInterval[1] > this.dateRangeEnd) this.dateRangeEnd = this.calendar._timeInterval[1];  
            } else {
                this.dateRangeStart = this.calendar._timeInterval[0];
                this.dateRangeEnd = this.calendar._timeInterval[1]; 
            }

            // in der API wird's meistens date_start und date_end sein, der Kalender braucht startTime und endTime
            for (let calendaritem of calendarItemsList) {
                calendaritem["startTime"] = calendaritem[this.filterOptionDateStart];
                calendaritem["endTime"] = calendaritem[this.filterOptionDateEnd];
            }

            //console.log("CalendarData RESPONSE:: ", this.lastResponse);

            // set CalendarData (Kalender ist schon instanziiert)
            this.setCalendarData(calendarItemsList, calendarMode, <string>calendarDisplayDate); 

        } else {

            alert("ERROR - refere to the console");
            console.log("_onLoadCalendarDataError: ", response);

        }
    }

    _onLoadCalendarDataError(err): void {
        alert("ERROR - refere to the console");
        console.log("_onLoadCalendarDataError: ", err);
    }

    // Create or update calendar Wrapper
    // 
    // this. will create the calendar with a default config. because the config is very versatile. you can acces the calendar through this.getWidgetBy[Name|Id] later
    //gibt die WidgetId: string von ddem angelegten calendar zurück
    // wenn ein existierender calendar "kreiert" wird, wird einfach setData passieren. Wenn der alte Kalender destroyed werden soll (weil neuer config z.b.), --> removeWidgetById() zuerst
    createCalendar(containerNode: HTMLElement, domNodeHeight: number, showButtons: boolean, calendarMode?: string, displayDate?: string): string {
        return this._setCalendar(null, containerNode, domNodeHeight, showButtons, calendarMode, displayDate);
    }

    setCalendarData(entityList: Array<moreCoreCalendarItem>, calendarMode?: string, displayDate?: string): void {
        this._setCalendar(entityList, null, null, null, calendarMode, displayDate);
    }
    
    _setCalendar(
        entityList?: Array<moreCoreCalendarItem>,
        containerNode?: HTMLElement,
        domNodeHeight?: number,
        showButtons?: boolean,
        calendarMode?: string,
        displayDate?: string,  /* YYYY-MM-dd*/
    ): string {

        let calendar: MdsLax<InstanceType<typeof moreCoreCalendar>> = null;
        let newCalendarId: string = null;
        let calendarData: moreCoreCalendarData = null;
        let widgetRegistryObj: widgetRegistryObj = null;

        if (this.calendar) {
            widgetRegistryObj = this.getWidgetRegistryObjByWidgetId(this.calendar.id);
            calendar = this.calendar;
        } 

        if (calendar == null) { 
            // wenn noch kein Kalender da ist, kreieren wir einen
            if (containerNode) {

                calendar = new moreCoreCalendar();
                this.calendar = calendar;
                newCalendarId = calendar.id;
                this.UiModder.domStyle.set(this.calendar.mainContainer, "position", "relative")

                if (this._isMobile === true) {

                    this.fullScreenDlg = new FullscreenDialog({ destroyOnClose: false });
                    this.fullScreenDlg.addNodeToContent(this.calendar.domNode);
                    this.fullScreenDlg.show();
                } else {
                    calendar.placeAt(containerNode);
                }

                if (displayDate) {
                    calendar.setDate(displayDate);
                }

                // addWidgetToRegistry(widget, containerNode, widgetName, dataPropertyName? entityListPropertyName?, requestUrl?, tableLayoutName?)
                this.addWidgetToRegistry(calendar, containerNode);

                if (showButtons) {
                    this.calendarButtons = new Calendar_Buttons();
                    this.configureButtons(calendar);
                    this.calendarButtons.placeAt(containerNode, "first");
                }

                calendar.on("timeIntervalChange", lang.hitch(this, function (args) {
                    if (this._loadCalendarDataTimeout != null) {
                        clearTimeout(this._loadCalendarDataTimeout)
                    }
                    this._loadCalendarDataTimeout = setTimeout(lang.hitch(this, function () {
                        this.loadCalendarData();
                    }), 200);
                }));

                this.UiModder.domStyle.set(calendar.domNode, "height", domNodeHeight + "px");

                /*
                if (showButtons) {
                    calendar.showCalendarButtons(true); // buttons zeigen
                } else {
                    calendar.showCalendarButtons(false); 
                }
                */

                //calenar configurieren
                calendar.configureCalendar(); // default config - setzt das displayDate zu heute

                if (this.calendar_columnViewHeadTextAttr) this.calendar.setColumnView_headText_attribute(this.calendar_columnViewHeadTextAttr);
                if (this.calendar_columnViewBodyTextAttr) this.calendar.setColumnView_bodyText_attribute(this.calendar_columnViewBodyTextAttr);

            } else {

                alert("no calendar ContainerNode specified");
                return null;
            }        
        } else if (this._isMobile === true && this.fullScreenDlg) {
            this.fullScreenDlg.show();
        }

        if (calendar && entityList) { // interface calendarData { items: Array<moreCoreCalendarItem>, mode: string, displayDate: string }

            calendarData = { items: entityList, mode: calendarMode, displayDate: displayDate };

            calendar.setData(calendarData);
        } else {
            if (this._loadCalendarDataTimeout != null) {
                clearTimeout(this._loadCalendarDataTimeout)
            }
            this._loadCalendarDataTimeout = setTimeout(lang.hitch(this, "loadCalendarData"), 500);
        }

        if (!containerNode && widgetRegistryObj && widgetRegistryObj.containerNode) {
            containerNode = widgetRegistryObj.containerNode;
        }

        if (containerNode) this.UiModder.domClass.remove(containerNode, "w3-hide");

        return newCalendarId;
    }

    configureButtons(calendar: MdsLax<InstanceType<typeof moreCoreCalendar>>) {

       // Finderviewbase ist so eh nicht mehr einsatzfähig. die Buttons haben ihre Nodes inzwischen schon auf private gesetzt.
    }

    _setCalendarMode( calendarMode: string): void {

        if (this.calendar && calendarMode && typeof calendarMode == "string") {

            switch (calendarMode) {
                case "week":
                    this.calendar.set("dateIntervalSteps", 1);
                    this.calendar.set("dateInterval", "week");
                    break;
                case "day":
                    this.calendar.set("dateIntervalSteps", 1);
                    this.calendar.set("dateInterval", "day");
                    break;
                case "month":
                    this.calendar.set("dateInterval", "month");
                    this.calendar.set("dateIntervalSteps", 1);
                    break;
                case "3days":
                    this.calendar.set("dateIntervalSteps", 3);
                    this.calendar.set("dateInterval", "day");
                    break;
                case "2weeks":
                    this.calendar.set("dateIntervalSteps", 2);
                    this.calendar.set("dateInterval", "week");
                    break;
                default:
                    console.log("parameter not found");
                    break;
            }
        }
    }

    // Hervorheben of an item ein- und ausschalten
    _onCalenderHighlightItemChange(bool: boolean): void {
        if (this.calendar) {
            if (bool == false) {
                if (this.calendar.itemToHighlight_ID) this.calendar.lastHighlightedCalendarItem_ID = this.calendar.itemToHighlight_ID;

                this.calendar.disableHighlighting();
            } else {

                if (!this.calendar.itemToHighlight_ID && this.calendar.lastHighlightedCalendarItem_ID) this.calendar.setItemToHighlight(this.calendar.lastHighlightedCalendarItem_ID);
            }
        }
    }
    
    //// CALENDAR handling -----------------------------------------------------END
    ////############################################################################
    //// TABLE handling -------------------------------------------------------START

    // NESTED TABLE -----------------------------------------START

    _setNestedTable(tableParams: TableConfiguration): string {
        var table: MdsLax<InstanceType<typeof NestedTable>>;
        var lists: NestedTableConfig;
        let tableId: string = null;

        var registryObj: widgetRegistryObj;

        if (tableParams.widgetName) {
            registryObj = this.getWidgetRegistryObjByWidgetName(tableParams.widgetName);
            if (registryObj && registryObj.widget) table = registryObj.widget;
        }

        if (!tableParams.containerNode && registryObj && registryObj.containerNode) {
            tableParams.containerNode = registryObj.containerNode;
        }

        if (!tableParams.containerNode) {
            alert("You need a continerNode as arument for creating a new table");
            console.log("You need a continerNode as arument for creating a new table")
            return;
        }

        //alte Tabelle weg
        if (table != null) this.removeWidgetById(table.id);
        tableParams.containerNode.innerHTML = null;

        this.showError(false);

        table = new NestedTable(); // default

        tableId = table.id;

        this.addWidgetToRegistry(table, tableParams.containerNode, tableParams.widgetName);

        if (tableParams.tableFormatterfunction != null) table.setFormatter(tableParams.tableFormatterfunction);


        console.log("LAYOUTS: ", this._layouts);
        if (this._layouts) {

            if (!Array.isArray(this._layouts)) { // beider BST wird es ein array sein , hier brauchen wir ein document
                (<MdsLax<InstanceType<typeof NestedTable>>>table).addLineConfig(<NestedTableConfig>this._layouts);
                this.UiModder.domConstruct.place(table.domNode, tableParams.containerNode);
            } else {
                alert("this._layouts is an array, most likely you are using the wrong Layouts Configuration Structure for NestedTable. ");
                console.log("this._layouts is an array, most likely you are using the wrong Layouts Configuration Structure for NestedTable. ");
            }
        } else {
            this.showError("Layout .. ??");
        }

        if (tableParams.entityList) {

            table.setData(tableParams.entityList);

            this.displayDataSection(tableParams.containerNode, "start");
        }

        if (tableParams.containerNode) this.UiModder.domClass.remove(tableParams.containerNode, "w3-hide");
        table.domNode.setAttribute("data-cy", "finderNestedTable:" + (<any>this).declaredClass);

        return tableId;
    }


    // NESTED TABLE -----------------------------------------END
    // Static TABLE -----------------------------------------START
    

    // Create or update Table wrapper
    //gibt die WidgetId: string von der angelegten Tabelle zurück
    protected createTable(tableName: string, containerNode: HTMLElement, selectedLayoutName: string, entityList?: Array<object>, formatterFunction?: StaticTable.formatterCallback): MdsLax<InstanceType<typeof StaticTable>> {
        let tableParams: TableConfiguration = {
            selectedLayoutName: selectedLayoutName,
            entityList: entityList,
            widgetName: tableName,
            containerNode: containerNode,
            tableFormatterfunction: formatterFunction,
        //    layoutStyle: layoutStyle
        };
        return this._setTable(tableParams);
    }
    protected _setTable(tableParams: TableConfiguration): MdsLax<InstanceType<typeof StaticTable>> {
        let table: MdsLax<InstanceType<typeof StaticTable>>;
        let layout: StaticTable.Layout;
        let tableId: string = null;


        let registryObj: widgetRegistryObj;

        if (tableParams.widgetName) {
            registryObj = this.getWidgetRegistryObjByWidgetName(tableParams.widgetName);
            if (registryObj && registryObj.widget) table = registryObj.widget;
        }

        // falls schon vorhanden: prüfen ob Layouts noch zusammenpassen
        if (table && registryObj) {
            if (tableParams.selectedLayoutName == null || // kein bestimmtes Layout eingestellt
                ( registryObj.tableLayoutName && registryObj.tableLayoutName == tableParams.selectedLayoutName)) {
                // table existiert und das layout ht sich nicht geändert - wir brauchen lediglich setData()

            } else {
                // die table passt nicht - zerstören!
                this.removeWidgetById(table.id);
                table = null;
            }
        }

        if (!table) {
            // layout hat sich geändert oder es ist eine neue tabelle

            if (!tableParams.containerNode && registryObj && registryObj.containerNode) {
                tableParams.containerNode = registryObj.containerNode;
            }

            if (!tableParams.containerNode) {
                alert(this.id + ": cannot create table - containernode missing");
                console.log(this.id + ": cannot create table - containernode missing");
                return;
            }

            //alte Tabelle weg
            //console.debug("alte Table destroy?", table, tableParams);
            if (table != null) table.destroy();
            tableParams.containerNode.innerHTML = null;

            let layoutname = tableParams.selectedLayoutName ? tableParams.selectedLayoutName : this.selectedLayoutName;

            layout = this._getLayoutByName(layoutname);
            if (layout == null) layout = this._getLayoutByName("default"); // fallback

            this.showError(false);

            table = new StaticTable(); // default

            tableId = table.id;

            this.addWidgetToRegistry(table, tableParams.containerNode, tableParams.widgetName);

            if (tableParams.tableFormatterfunction != null) table.setFormatter(tableParams.tableFormatterfunction);

            if (layout != null) {
                //console.debug("FinderViewBase SetTable", tableParams, layout);

                table.setTableLayout(layout);

                this.UiModder.domConstruct.place(table.domNode, tableParams.containerNode);

            } else {
                this.showError("Layout .. ??");
            }
        }

        if (tableParams.entityList) {

            table.setData(tableParams.entityList);
            let row: StaticTable.StaticTableRow<any> = null;

            if (this.scrollTargetIndex) {
                
                let group = table.getRowGroup(this.scrollTargetIndex);

                console.debug("get row from scroll-target", this.scrollTargetIndex, group);

                if (group) {
                    if (group.rows.length) {
                        row = group.rows[0];
                    }
                }
            }

            

            if (row) {
                this.displayDataSection(row.node, "end", "highlight", 5000);
            }
            else {
                this.displayDataSection();
            }

        }

        if (tableParams.containerNode) this.UiModder.domClass.remove(tableParams.containerNode, "w3-hide");

        this.UiModder.domAttr.set(table.domNode, "data-table-type", (<any>this).declaredClass);
        table.domNode.setAttribute("data-cy", "finderTable:" + (<any>this).declaredClass);

        return table;
    }
    // Static TABLE -----------------------------------------END
    private scrollTargetIndex: any = null;

    //response:  {layoutname: bla, metadata:bla,  entitylistPropertyname: [...entities]}
    protected processFilterListResponse(response: more.PackedEntitylistResult<any>) { 

        console.log("Filterdata response: ", response, this.getDirty(), this._completeList)
        this.scrollTargetIndex = null;

        if (this.entityListAttributeName && response[this.entityListAttributeName]) {

            if (this.getDirty() === true) {
                this._completeList = [];
            }

            //this._completeList_lastResponse_FirstEntityIndex = this._completeList.length? this._completeList.length-1 : 0

            for (let entity of response[this.entityListAttributeName]) {

                let tableEntity: object;

                if (this.tableEntityPath) {
                    tableEntity = this.PitHelper.getEntityAttributeValue(entity, this.tableEntityPath, more.PitHelperStructureFormatType.json);
                    if (!tableEntity) console.log("PitHelper could not get the entityAttributeValue for ", this.tableEntityPath, " in ", entity)
                } else {
                    tableEntity = entity;
                }

                // Update the DateRange 
                this.dateRangeStart == null;
                this.dateRangeEnd == null;
                if (entity[this.filterOptionDateStart] && entity[this.filterOptionDateEnd]) {
                    var dateVariable_start = new Date(entity[this.filterOptionDateStart]);
                    var dateVariable_end = new Date(entity[this.filterOptionDateEnd]);

                    if (this.dateRangeStart == null) {
                        this.dateRangeStart = dateVariable_start;
                    } else {
                        if (dateVariable_start < this.dateRangeStart) this.dateRangeStart = dateVariable_start;
                    }

                    if (this.dateRangeEnd == null) {
                        this.dateRangeEnd = dateVariable_end;
                    } else {
                        if (dateVariable_end > this.dateRangeEnd) this.dateRangeEnd = dateVariable_end;
                    }
                }

                

                if (this._completeList.length) {
                    let index: number = -1;
                    for (let i = 0; i < this._completeList.length; i++) {
                        let entry = this._completeList[i];
                        let value = entry[this.primaryKeyAttribute];
                        let compareValue = tableEntity[this.primaryKeyAttribute];
                        if (value == compareValue && value && compareValue) {
                            index = i;
                            break;
                        }
                    }
                    if (index == -1) {
                        this._completeList.push(tableEntity);
                        if (this.scrollTargetIndex == null) {
                            this.scrollTargetIndex = this._completeList.length - 1;
                        }
                    } else {
                        this._completeList[index] = tableEntity;
                    }
                } else {
                    this._completeList.push(tableEntity);
                    this.scrollTargetIndex = 0;                    
                }
            }

            //this._completeList_lastResponse_LastEntityIndex = this._completeList.length ? this._completeList.length - 1 : 0;

            this.processFilterListResponse_callback();


        } else {
            console.error("set this.entityListAttributeName please")
        }
    }

    

    //// TABLE handling -------------------------------------------------------END

    //// overrides for the child class -----------------------------------------START
 

    processFilterListResponse_callback(): void {

    }

    //// overrides for the child class -----------------------------------------START

    //// getters &&   setters ----------------------------------------------START
    getDocumentTitle(): string { return this.documentTitle; }
    setDocumentTitle(title: string) {
        this.documentTitle = title;
        document.title = this.documentTitle;
    }
    _getDocumentTitleAttr(): string { return this.getDocumentTitle(); }
    _setDocumentTitleAttr(title: string): void { this.setDocumentTitle(title); }

    //// getters &&   setters ----------------------------------------------END


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        // touchscreen
        if ("ontouchstart" in document.documentElement) {
            this._isMobile = true;
        }

        topic.subscribe("moreCoreCalendar/timeIntervalChange", lang.hitch(this, function () {
            if (this._loadCalendarDataTimeout != null) {
                clearTimeout(this._loadCalendarDataTimeout);
            }

            this._loadCalendarDataTimeout = setTimeout(lang.hitch(this, function () {
                this.loadCalendarData();
            }), 200);
        }))        
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (this.documentTitle) document.title = this.documentTitle; // getter und setter  TODO

    }

//    /* ohne Settitles gehts kompilieren nicht bei manchen Mehrfachvererbungen...*/
//    setTitles(windowTitle?: string, topBarTitle?: string) {
//        let self: any = this;
//        self.inherited(arguments);
//    }
}

export default mdsWidget(FinderViewBase);